export default {
  "menu": {
    "aiCustomerServiceSettings": "Customer Service Settings",
    "aiCustomerServiceMeeting": "Conversation List",
    "smartConstruction": "Smart Center",
    "agentManager": "Agent Manager",
    "workOrderList": "Work Order List",
    "aiCustomerService": "AI Customer Service",
    "multiSourceFeedbackCheck": "Multi source feedback query",
    "productSettings": "Settings",
    "rolePermissions": "Permissions",
    "memberManagement": "Member",
    "systemSettings": "System",
    "questionnaireManagement": "Questionnaire",
    "feedbackSettings": "Settings",
    "feedbackInquiry": "Inquiry",
    "feedbackOperation": "Feedback",
    "personalCenter": "Personal Center",
    "feedbackStatistics": "Statistics",
    "problemFollowUp": "Problem",
    "userVoice": "User Voice",
    "dataInsight": "Insight",
    "overview": "Home",
    "autoMonitorSetting": "autoMonitor",
    "laboratory": "laboratory",
    "publicExploration": "publicExploration",
    "loganalysis": "loganalysis",
    "aiLogAnalysis": "AI LogAnalysis",
    "logDetail": "loganalysisDetail",
    "alphaTasklist": "alphaTasklist",
    "betaTasklist": "betaTasklist",
    "summaryFeedback": "summaryFeedback",
    "modelManagement": "modelManagement",
    "exchangeProcessing": "exchangeProcessing",
    "feedbackLayout": "feedbackLayout",
    "aiKnowledge": "AI Knowledge Base",
    "knowledgeCorpus": "Corpus",
    "agentEvaluation": "Agent Evaluation",
    "smartClassify": "Smart Classify",
  },
};